import { createSelector } from 'reselect'
import filtersSelector from '../filtersSelector'
import modelsPageFiltersEnabledSelector from '../modelsPageFiltersEnabledSelector'
import { FiltersState } from '../../reducers/filtersReducer'

const modelSelectedFiltersSelector = createSelector(
    filtersSelector,
    modelsPageFiltersEnabledSelector,
    (filters, modelsPageFiltersEnabled): FiltersState => {
        return modelsPageFiltersEnabled ? filters : {}
    },
)

export default modelSelectedFiltersSelector